import { useState } from "react";
import { Lock, FileText, ArrowDownCircle, ArrowUpCircle, PlusCircle, MinusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MoveDialog } from "@/components/cash/MoveDialog";
import { CloseCashDialog } from "@/components/cash/CloseCashDialog";
import { CashReport } from "@/components/cash/CashReport";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, CASH_MOVE_LABELS } from "@/lib/api";
import { directPrint } from "@/lib/qz";
import { cashClose } from "@/lib/receipts";
import { toast } from "sonner";

const ICONS = { suprimento: ArrowDownCircle, sangria: ArrowUpCircle, entrada: PlusCircle, saida: MinusCircle };

export function CashActions({ item, onChanged, extended = false }) {
  const { session } = useAuth();
  const [move, setMove] = useState(null);
  const [closing, setClosing] = useState(false);
  const [report, setReport] = useState(null);
  const [closed, setClosed] = useState(false);
  const { id, number } = item.session;
  const partial = async () => { try { setReport((await api.get(`/cash/sessions/${id}`)).data); } catch (e) { toast.error(errMsg(e)); } };
  const types = extended ? Object.keys(CASH_MOVE_LABELS) : ["suprimento", "sangria"];
  const closeReport = () => { setReport(null); if (closed) onChanged(); };
  return (
    <>
      {types.map((k) => { const I = ICONS[k]; return <Button key={k} size="sm" variant="outline" onClick={() => setMove(k)} data-testid={`cash-${k}-btn-${number}`}><I className="h-4 w-4 mr-1" />{CASH_MOVE_LABELS[k]}</Button>; })}
      <Button size="sm" variant="outline" onClick={partial} data-testid={`cash-partial-btn-${number}`}><FileText className="h-4 w-4 mr-1" />Parcial</Button>
      <Button size="sm" variant="destructive" onClick={() => setClosing(true)} data-testid={`cash-close-btn-${number}`}><Lock className="h-4 w-4 mr-1" />Fechar caixa</Button>
      {move && <MoveDialog type={move} sessionId={id} onClose={() => setMove(null)} onDone={() => { setMove(null); onChanged(); }} />}
      <CloseCashDialog open={closing} onOpenChange={setClosing} cash={item} onClosed={(d) => { setClosing(false); setClosed(true); setReport(d); directPrint(session, "cash", (pr) => cashClose(d, session.tenant.nome_fantasia, pr)); }} />
      <CashReport s={report} store={session.tenant.nome_fantasia} onClose={closeReport} />
    </>
  );
}
